<template>
  <div class="a-input-text">
    <input
      ref="input"
      type="text"
      class="a-input-text__body"
      :value="value"
      :placeholder="placeholder"
      :maxlength="maxLength"
      @input="updateValue"
    />
  </div>
</template>

<script>
export default {
  name: 'AInputText',
  props: {
    required: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    maxLength: {
      default: 2000
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('input', {
        value: event.target.value.trim()
      })
    }
  }
}
</script>
